import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class LoginActivate  {
  constructor(private authService: AuthService, private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['login']);
    } else {
      return true;
    }
  }
}

@Injectable()
export class RoleGuard  {
  user: any;
  constructor(private authService: AuthService, private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
    this.user = this.authService.getLoggedUser()
    var found = true;
    var optionList = [];

    var elementRoles = route.data.role.split(',')
    for (let i = 0; i < elementRoles.length; i++) {
      const r = elementRoles[i];
      optionList.push(r)
    }

    if (route.data.minRoleCheck) {
      found = false;

      for (let i = 0; i < optionList.length; i++) {
        const o = optionList[i];
        if (this.checkOptionInRole(o)) {
          return true;
        }
      }

    }
    else {
      for (let i = 0; i < optionList.length; i++) {
        const o = optionList[i];

        if (!this.checkOptionInRole(o)) {
          found = false;
          break;
        }
      }
    }

    if (!found) {
      this.router.navigate(['404']);
    } else
      return found;

  }


  checkOptionInRole(code) {
    if (this.user && this.user.RoleInfo) {

      for (let i = 0; i < this.user.RoleInfo.length; i++) {
        const role = this.user.RoleInfo[i];
        if (role == code) {
          return true;
        }
      }
    }
    return false;
  }

}
